<fgb-navigation-indicator></fgb-navigation-indicator>

<ng-container *ngIf="!navigationSettings?.mobile.hidden">
  <fgb-mobile-nav-menu *ifScreenSize="screenType.Mobile"></fgb-mobile-nav-menu>
</ng-container>
<fgb-nav-bar *ifScreenSize="screenType.Desktop"></fgb-nav-bar>

<fgbcl-notification-toast></fgbcl-notification-toast>

<div id="main" role="main">
  <div class="full-page-container"><router-outlet></router-outlet></div>
</div>

<fgb-footer></fgb-footer>
